exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".h-100p[data-v-69abb422]{height:100%}.header-table-divider[data-v-69abb422]{margin-top:2%}.btn-new-identity[data-v-69abb422]{background-color:#0032a0!important;color:#fff}.v-btn[data-v-69abb422]{text-transform:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69abb422","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/authandvideocall/AuthAndVideoCall.vue
// module id = 818
// module chunks = 0